// extracted by mini-css-extract-plugin
module.exports = {"badge":"CampaignBadge_badge__HJdS1","icon":"CampaignBadge_icon__04P2y"};